import "prismjs/themes/prism.css"

const { getGoogleTagId, getPagePath } = require("./src/utils/google-tag")

// WebMCP — expose site tools to AI agents via the browser
export const onClientEntry = () => {
  if (typeof window === "undefined") return
  if (!navigator.modelContext) return

  try {
    navigator.modelContext.provideContext({
      name: "catwomaniya",
      version: "1.0.0",
      description:
        "Personal blog by Shweta Das — B2B growth, AI, internet culture, and things worth sharing.",
      tools: [
        {
          name: "getRSSFeed",
          description:
            "Fetch the full-text RSS feed of all published blog posts",
          parameters: { type: "object", properties: {}, required: [] },
          handler: async () => {
            const res = await fetch("https://catwomaniya.xyz/rss.xml")
            return res.text()
          },
        },
        {
          name: "getSitemap",
          description: "Fetch the XML sitemap listing every published URL",
          parameters: { type: "object", properties: {}, required: [] },
          handler: async () => {
            const res = await fetch("https://catwomaniya.xyz/sitemap.xml")
            return res.text()
          },
        },
        {
          name: "getPostMarkdown",
          description:
            "Fetch a blog post as raw Markdown. Pass the post slug (e.g. /my-post/).",
          parameters: {
            type: "object",
            properties: {
              slug: {
                type: "string",
                description: "The post slug starting with /",
              },
            },
            required: ["slug"],
          },
          handler: async ({ slug }) => {
            const base = slug.endsWith("/") ? slug : slug + "/"
            const res = await fetch(
              `https://catwomaniya.xyz${base}index.md`
            )
            return res.ok ? res.text() : null
          },
        },
      ],
      resources: [
        {
          name: "RSS Feed",
          uri: "https://catwomaniya.xyz/rss.xml",
          mimeType: "application/rss+xml",
        },
        {
          name: "LLMs.txt",
          uri: "https://catwomaniya.xyz/llms.txt",
          mimeType: "text/plain",
        },
        {
          name: "Agent Skills",
          uri: "https://catwomaniya.xyz/.well-known/agent-skills/index.json",
          mimeType: "application/json",
        },
      ],
    })
  } catch (_) {
    // WebMCP not supported in this browser — silently ignore
  }
}

const trackPageView = location => {
  const googleTagId = getGoogleTagId()

  if (!googleTagId || !window.gtag) {
    return
  }

  window.gtag("event", "page_view", {
    page_title: document.title,
    page_path: getPagePath(location),
    page_location: window.location.href,
    send_to: googleTagId,
  })
}

export const onInitialClientRender = () => {
  trackPageView(window.location)
}

export const onRouteUpdate = ({ location, prevLocation }) => {
  if (!prevLocation) {
    return
  }

  trackPageView(location)
}
